module.exports = __webpack_public_path__ + "img/WTC.6e5d46dc.svg";